import Swiper from 'swiper/js/swiper.min';

export default function () {
    new Swiper('.swiper-container', {
        effect: 'fade',
        loop: true,
        autoplay: true,
        speed: 1000
    });

    new Swiper('.swiper-header-overlay', {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        autoplay: {
            delay: 3000
        },
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        loopFillGroupWithBlank: false
    });

    new Swiper('.swiper-header-background', {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        autoplay: {
            delay: 3000
        },
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        loopFillGroupWithBlank: false
    });

    var galleryThumbs = new Swiper('.c-shoppart__images--small', {
        direction: 'vertical',
        spaceBetween: 0,
        loopedSlides: 3,
        slidesPerView: 3,
        watchSlidesVisibility: true,
        watchSlidesProgress: true
    });

    var galleryTop = new Swiper('.c-shoppart__images--big', {
        effect: 'fade',
        spaceBetween: 20,
        loopedSlides: 3,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        thumbs: {
            swiper: galleryThumbs
        }
    });
}
